import _ from 'lodash';

export const filtersToQuery = (filters) => {
    let obj = {};
    let query = '';

    Object.keys(filters).forEach(k => {
        const newKey = k.replace(/\.?([A-Z]+)/g, function (x, y) { return "_" + y.toLowerCase() }).replace(/^_/, "");
        obj[newKey] = filters[k];
    })

    Object.keys(obj).forEach(k => {
        if (_.isArray(obj[k]) == true && _.isEmpty(obj[k]) == false) {
            obj[k].forEach((v, i) => {
                if (typeof(v) === 'object') {
                    Object.keys(v).forEach(v2 => {
                        query += `${k}[${i}][${encodeURIComponent(v2)}]=${encodeURIComponent(v[v2])}&`;
                    });
                }
                else if(v != null && v !== '') {
                    query += `${k}[]=${encodeURIComponent(v)}&`;
                }
            });
        }
        else if (_.isArray(obj[k]) == false && obj[k] !== '') {
            query += `${k}=${encodeURIComponent(obj[k])}&`;
        }
    });

    if (query !== '') {
        query = query.slice(0, -1);
    }

    return query;
}
